import Header from "../../components/Header";
import ContentWrapper from "../../components/ContentWrapper";
import BoxSignsLpSafety from "./_components/BoxSignsLpSafety";

const SignsLpSafety = () => (
  <>
    <div className="px-[10px] pt-[5px]">
      <Header />
    </div>
    <ContentWrapper>
      <BoxSignsLpSafety />
    </ContentWrapper>
  </>
);

export default SignsLpSafety;
